<div class="galleria">
    <p-galleria [value]="displayedCustomers" [responsiveOptions]="responsiveOptions"
        [containerStyle]="{'max-width': '640px'}" [numVisible]="5"
        [showThumbnails]="false" [showIndicators]="true" [changeItemOnIndicatorHover]="false">
        
        <ng-template pTemplate="item" let-item>
            <app-customer-telling [customer]="item"></app-customer-telling>
        </ng-template>
        
    </p-galleria>
</div>